import React from "react";
import authStore from "../../store/auth-store";
import { browserHistory } from "react-router";

export default class UserCard extends React.Component {
    constructor() {
        //console.log("-------- card constructor fired");
        super();
        this.state = {
            user: authStore.getToken().user
        }
    }

    handleSingOut() {
        //alert("all is well");
        authStore.deleteToken();
        browserHistory.push("/login");
    }

    render() {
        return (
            <div className="userCard">


                <div className="pointer" style={{ borderBottomColor: "#c7c7c7", top: "-11px", right: "10px" }}></div>
                <div className="pointer" style={{ borderBottomColor: "white", top: "-10px", right: "10px" }}></div>

                <div style={{ display: "flex", margin: "20px" }}>

                    <i className="fa fa-user" aria-hidden="true" style={
                        {
                            color: "white",
                            lineHeight: "88px",
                            display: "inline-block",
                            width: "96px", height: "96px",
                            background: "#6c5484",
                            fontSize: "5em",
                            textAlign: "center",
                            borderRadius: "50%"
                        }
                    }></i>

                    <div style={{ position: "relative", height: "96px", width: "144px", marginLeft: "20px" }}>
                        <h2 style={{ fontSize: ".9em" }}>{this.state.user.userName}</h2>
                        <p style={{ fontSize: ".7em", color: "gray", marginTop: "5px" }}>{this.state.user.emailId}</p>
                        <button className="btn btnOk" style={{ marginBottom: 0, position: "absolute", left: 0, bottom: 0 }}>My Account</button>
                    </div>
                </div>
                <div className="footerBar">
                    <button onClick={this.handleSingOut.bind(this)} className="btn btnGray btnRight" style={{ marginRight: "10px" }}>Sign Out</button>
                </div>

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/jsx/components/fragments/user-card.jsx